import { render, staticRenderFns } from "./ContaEmail.vue?vue&type=template&id=4f140e0d&"
import script from "./ContaEmail.vue?vue&type=script&lang=js&"
export * from "./ContaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports